<template>
  <!-- What the system just booked in the GL by itself (useBooked.js). Top right,
       so it never covers a page's own message at the bottom; long enough to be
       read; closes on Close. -->
  <v-snackbar
    v-model="visible"
    location="top right"
    :timeout="20000"
    color="surface"
    variant="elevated"
    vertical
    max-width="560"
  >
    <div v-if="booked" class="text-body-2">
      <div class="d-flex align-center mb-1">
        <v-icon size="18" color="primary" class="me-2">mdi-book-open-variant</v-icon>
        <span class="font-weight-medium">{{ booked.title || "Booked in the Journal" }}</span>
      </div>
      <div class="text-body-small text-medium-emphasis mb-2">
        {{ booked.count === 1 ? "The system wrote this entry in the Journal:" : `The system wrote ${booked.count} entries in the Journal:` }}
      </div>

      <!-- Up to three entries, each with its lines -->
      <div v-for="e in booked.entries" :key="e.entryNo" class="mb-2">
        <div class="text-body-small">
          <span class="font-weight-medium">{{ e.entryNo }}</span> · {{ fmtDay(e.date) }} — {{ e.description }}
        </div>
        <div v-for="(l, i) in e.lines" :key="i" class="d-flex ga-3 text-body-small">
          <span class="flex-grow-1" :class="{ 'ps-4': l.credit > 0 }">{{ l.debit > 0 ? "DR" : "CR" }} {{ l.code }} {{ l.name }}</span>
          <span class="text-no-wrap">{{ fmt(l.debit || l.credit) }}</span>
        </div>
      </div>

      <!-- Many entries: the totals per account -->
      <template v-if="booked.totals">
        <div class="text-body-small text-medium-emphasis mb-1">Together, per account:</div>
        <div v-for="t in booked.totals" :key="t.code" class="d-flex ga-3 text-body-small">
          <span class="flex-grow-1">{{ t.code }} {{ t.name }}</span>
          <span class="text-no-wrap">{{ t.debit ? `DR ${fmt(t.debit)}` : "" }}{{ t.debit && t.credit ? " · " : "" }}{{ t.credit ? `CR ${fmt(t.credit)}` : "" }}</span>
        </div>
      </template>
    </div>
    <template v-slot:actions>
      <v-btn variant="text" @click="visible = false">Close</v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
import { useBooked } from "@/composables/useBooked.js";

const { booked, visible } = useBooked();

const fmt = (n) => Number(n || 0).toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const fmtDay = (d) => (d ? new Date(`${d}T00:00:00`).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" }) : "");
</script>
